(function () {
  'use strict';

  const unavailableMessage = 'Esta función no está disponible todavía.';

  function supportRoot(root) {
    if (!root || typeof root.querySelector !== 'function') return null;
    return root.matches?.('.pc-support') ? root : root.querySelector('.pc-support');
  }

  function applyUnavailableState(root) {
    const component = supportRoot(root);
    if (!component) return;
    component.dataset.pcSupportMode = 'unavailable';
    component.querySelectorAll('[data-pc-unavailable-control]').forEach((control) => {
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });
  }

  window.PersonalCenterViewModules = window.PersonalCenterViewModules || {};
  window.PersonalCenterViewModules.support = {
    load({ root, signal } = {}) {
      applyUnavailableState(root);
      if (signal?.aborted) {
        const error = new Error('Support view load was aborted.');
        error.name = 'AbortError';
        return Promise.reject(error);
      }
      return Promise.resolve({ data: { availability: 'unavailable' }, meta: { unavailable: true } });
    },

    render({ root } = {}) {
      applyUnavailableState(root);
    },

    handleAction({ event, action, root } = {}) {
      const component = supportRoot(root);
      if (!component || !action || !component.contains(action)) return false;
      event?.preventDefault?.();
      action.disabled = true;
      action.setAttribute('aria-disabled', 'true');
      action.setAttribute('data-pc-unavailable-reason', unavailableMessage);
      return true;
    },

    disconnect({ root } = {}) {
      applyUnavailableState(root);
    }
  };
})();
